import LightLayout from '../../../../../shared/Layouts/LightLayout'
import taskSandboxCss from '../taskSandbox.module.css'
import css from './firstTaskSandbox.module.css'
import sandboxCss from '../taskSandbox.module.css'
import CreateTextOptionModal from '../../CreateTextOptionModal'
import PngDropzone from '../../../../../shared/Dropzone/PngDropzone'
import { IImage, ITask } from '../../../../../types/tasks.types'
import TextOption from '../../TextOption'
import useSandboxTask from '../useSandboxTask'

interface IProps {
  onDraftTaskChange: <T extends keyof ITask>(value: ITask[T], key: T) => void
}

const FirstTaskSandbox = (props: IProps) => {
  const ctrl = useSandboxTask(props.onDraftTaskChange)

  const renderOptions = () => {
    return ctrl.draftTask.answerOptions.map((option, index) => (
      <TextOption
        option={option}
        index={index}
        key={index}
        onDelete={ctrl.handleOptionDelete}
        onChange={ctrl.handleOptionChange}
      />
    ))
  }

  return (
    <div className={taskSandboxCss.wrapper}>
      {ctrl.createOptionModalOpen && (
        <CreateTextOptionModal onClose={ctrl.toggleCreateOptionModal} onCreate={ctrl.handleOptionCreate} />
      )}
      <LightLayout>
        <div className={css.wrapper}>
          <div className={css.imageUpload}>
            <PngDropzone onFile={ctrl.handleImage} image={ctrl.draftTask.images[0] as IImage} />
          </div>
          <div className={css.options}>
            {renderOptions()}
            <div className={sandboxCss.addOption} onClick={ctrl.toggleCreateOptionModal}>
              Добавить карточку
            </div>
          </div>
        </div>
      </LightLayout>
    </div>
  )
}

export default FirstTaskSandbox
